/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiConditionFromJSON, ApiConditionToJSON, } from './ApiCondition';
export function ApiCreateUpdateReadConditionResponseFromJSON(json) {
    return ApiCreateUpdateReadConditionResponseFromJSONTyped(json, false);
}
export function ApiCreateUpdateReadConditionResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'result': !exists(json, 'result') ? undefined : ApiConditionFromJSON(json['result']),
    };
}
export function ApiCreateUpdateReadConditionResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'result': ApiConditionToJSON(value.result),
    };
}
